import { render, staticRenderFns } from "./Remittance.vue?vue&type=template&id=3877193e&scoped=true&"
import script from "./Remittance.vue?vue&type=script&lang=js&"
export * from "./Remittance.vue?vue&type=script&lang=js&"
import style0 from "./Remittance.vue?vue&type=style&index=0&id=3877193e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877193e",
  null
  
)

export default component.exports